import { Chart } from "react-google-charts";

export const GenericChart = (props) => {
  const { data, options, chartType, width, height } = props;

  return (
    <Chart
      chartType={chartType}
      width={width}
      height={height}
      data={data}
      options={options}
    />
  );
};
